export const defaultHtml = '<p>Insert custom HTML</p>';
